import type { FC, PropsWithChildren, ReactElement } from 'react';

import { ButtonClose } from '@/components/buttons';
import { type GeneralModalProps, Modal } from '@/components/Modal';
import type { ScModalContentProps } from '@/components/Modal/styled';
import { Skeleton } from '@/components/modals/ModalSkeleton';
import { useGetCommonStore } from '@/store';
import { IconComponent } from '../IconComponent';
import { ScStaticModal } from './styled';

export interface StaticModalProps
  extends PropsWithChildren,
    GeneralModalProps,
    ScModalContentProps {
  onClose: () => void;
  dark?: boolean;
  title?: string;
  pending?: boolean;
  maxWidth?: number;
  hideCloseBtn?: boolean;
  icon?: ReactElement;
  bgTransparent?: boolean;
  isHideTitleOnMobileS?: boolean;
  isNoPaddingMob?: boolean;
}

export const StaticModal: FC<StaticModalProps> = ({
  children,
  dark,
  title,
  onClose,
  pending,
  maxWidth,
  hideCloseBtn,
  icon,
  bgTransparent,
  isHideTitleOnMobileS,
  isNoPaddingMob,
  ...props
}) => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return (
    <Modal {...props}>
      {pending ? (
        <Skeleton />
      ) : (
        <ScStaticModal
          bgTransparent={bgTransparent}
          dark={dark}
          isHideTitleOnMobileS={isHideTitleOnMobileS}
          isNoPaddingMob={isNoPaddingMob}
          maxWidth={maxWidth}
        >
          {title && (
            <h1>
              {icon ? (
                icon
              ) : (
                <IconComponent name="termsAndConditionsIcon" size="40px" />
              )}
              {title}
            </h1>
          )}
          {!hideCloseBtn && (
            <ButtonClose
              gray={!isMobileDevice}
              onClick={onClose}
              right={isMobileDevice ? 16 : 12}
              top={isMobileDevice ? 16 : 12}
            />
          )}
          {children}
        </ScStaticModal>
      )}
    </Modal>
  );
};
